/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useMediaQueries } from "../../../shared";
import NewsVertical from "../shared/News/NewsVertical/NewsVertical";
import { useStyles } from "../styles";

const RightSide = () => {
  const { to1099, from1099, fromLg } = useMediaQueries();

  const { rightSide } = useStyles({
    to1099,
    from1099,
    fromLg
  });

  return (
    <div css={css(rightSide)}>
      <NewsVertical />
    </div>
  );
};

export default RightSide;
